<template>
  <div v-if="stockOrdersOut && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="stockOrdersOut"
    />
  </div>
</template>
<script>
import StockOuts from "@/api/stock_outs";

import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import makeData from "./makeData";
import { mapState } from "vuex";

export default {
  components: {
    MutiplePiecesPrint,
  },

  computed: {
    ...mapState(["accountUser"]),
  },

  data: () => ({
    formater: null,
    stockOrdersOut: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("stockOrderOut").then(
      function (response) {
        if (response.data.status.isOK()) {
          // console.log(response);
          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          StockOuts.stockOrdersOutPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stockOrdersOut = response.data.stock_outs;
                if (this.stockOrdersOut) {
                  this.stockOrdersOut = this.stockOrdersOut.map(
                    (stockOrderOut) => {
                      stockOrderOut.printDateMinutes =
                        this.$datetimeUtils.formatDateMinutes(new Date());
                      stockOrderOut.accountUserName = this.accountUser.name;
                      stockOrderOut.stock_order_details = Object.values(
                        stockOrderOut.stock_order_details
                      );
                      return makeData.processDetails(stockOrderOut);
                    }
                  );
                }
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>